<template>
    <div class="animated fadeIn equipmentList bgV2">
        <b-row>
            <b-col md="12">
                <gofix-tab
                        class="mt-3 contractPropertyTab"
                        :data="contract_tab"
                        :query-param="{id:$route.params.id}"
                        activeKey="properties"
                        arrows >
                    <template slot="gofixTab:properties">
                        <b-row no-gutters class="heig-frame-child">
                            <b-col md="3" class="pr-15">
                                <gofix-card title="Property" class="mb-0 contractTree h-100">
                                    <template slot="gofixCard:right_header">
                                        <gofix-button
                                            label="Save"
                                            class="scontract-service-button"
                                            :disabled="!$checkRole($accessModule.safety_app_project, 'update') || isAction"
                                            @click="save"
                                            :loading="isAction">
                                        </gofix-button>
                                    </template>
                                    <div class="contenAbsolute">
                                        <div class="tree-view-properties safety-app-tree">
                                            <tree ref="tree" :data="treeData" :options="opts" @node:clicked="select"  @tree:mounted="onTreeInit">
                                                <div slot-scope="{ node }" class="node-container"> {{ node.text }} </div>
                                            </tree>
                                        </div>
                                    </div>
                                </gofix-card>
                            </b-col>
                            <b-col md="9">
                                <gofix-card :title="breadCrumb" classHeader="mb-0" classContent="pt-33" class="mb-0 h-100">
                                    <b-row class="content">
                                        <b-col md="12" class="pb-20">
                                            <gofix-text-field label="Type" oneline>{{nodeInfo.type}}</gofix-text-field>
                                        </b-col>
                                        <b-col md="4">
                                            <gofix-text-field label="Parents" oneline>{{nodeInfo.parents}}</gofix-text-field>
                                        </b-col>
                                        <b-col md="4">
                                            <gofix-text-field label="Name" oneline>{{nodeInfo.name}}</gofix-text-field>
                                        </b-col>
                                    </b-row>
                                </gofix-card>
                            </b-col>
                        </b-row>
                    </template>
                </gofix-tab>
            </b-col>
        </b-row>
    </div>
</template>
<script>
    import tabData from '@/data/_tabs';
    import LiquorTree from 'liquor-tree'
    import { mapGetters } from 'vuex';

    const eventsList = [
        { name: 'node:checked', args: ['Node'] },
        { name: 'node:unchecked', args: ['Node'] },
    ]

    export default {
        name: 'supplier-properties',
        components: {
            [LiquorTree.name]: LiquorTree
        },
        data() {
            return {
                contract_tab: tabData.safety_projects,
                optionsType: [
                    {
                        value: 'Cluster',
                        text: 'Cluster',
                        disabled: false
                    },
                    {
                        value: 'Building',
                        text: 'Building',
                        disabled: false
                    },
                    {
                        value: 'Location',
                        text: 'Location',
                        disabled: false
                    },
                ],
                type: {
                    value: 'Cluster',
                    text: 'Cluster'
                },
                isLoadNode : 1 ,
                treeData: this.getData(),
                opts: {
                    minFetchDelay: 500,
                    fetchData: (node) => {
                        if(node.children && node.children.length > 0) return Promise.resolve([]);
                        if(this.isLoadNode)
                            return new Promise((resolve, reject) => {
                                this.isLoadNode = 0
                                global.axios(`api/s-contracts/${this.$route.params.id}/tree-properties/${node.data.id}`, {
                                    method: "GET",
                                    params: {
                                        // is_active: true
                                    },
                                    headers: {
                                        Accept: "application/json",
                                    }
                                })
                                    .then(response => {
                                        this.isLoadNode = 1;
                                        response.data.data.map(item=>{
                                            if(item.state.checked==null || item.state.checked==false) {
                                                node.states.checked = false
                                            }
                                        })
                                        if(!node.parent) resolve([]); // if node haven't parent will reset array

                                        resolve(response.data.data);
                                    })
                                    .catch(error => reject(error));
                            });
                    },
                    checkbox: true,
                    checkOnSelect: true, 
                    parentSelect: true,
                },
                rootId: null,
                replace: function(key, value) {
                    switch (key) {
                        case "children":
                            if (value.length > 0) {
                                return value;
                            } else {
                                return null;
                            }
                            break;
                        default:
                            return value;
                    }
                },
                isLoading: true,
                breadCrumb: '',
                isAction: false,
                checkedTrueID: [],
                checkedID: [],
                checkedIDUpdate: [],
                removeID: [],
                nodeInfo : {
                    parents :'',
                    name : '',
                    type :''
                },
                timer: {
                    save: null,
                },
                removeNodes: []
            }
        },
        mounted() {
            // eventsList.forEach(e => {
            //     this.$refs.tree.$on(e.name, this.initEventViewer(e))
            // })
        },
        computed: {
            ...mapGetters({
                scontract: 'ContractController/SContract',
                ClientContractID: 'ContractController/ClientContractID',
            }),
            eventsList() {
                return this.events.concat().reverse()
            }
        },
        created() {
            if(!this.scontract) {
                this.$store.dispatch( 'ContractController/getSContract', this.$route.params.id)
                    .catch(error => { this.$router.push(`/v2/safety-app-project`) })
            }
            if (this.$store.state.controller.PropertyController.property_type.length == 0) {
                this.$store.dispatch('PropertyController/getListPropertyType')
                    .then(result => {
                        if (result.data.data.length > 0) this.property_type_id = result.data.data[0].id;
                    })
            } else
                this.property_type_id = this.$store.state.controller.PropertyController.property_type[0].id
        },
        watch: {},
        methods: {
            onTreeInit() {
                eventsList.forEach(e => {
                    this.$refs.tree.$on(e.name, this.initEventViewer(e))
                })
            },
            initEventViewer(event) {
                const goble = this;
                const events = this.events
                return function(node, newNode) {
                    let id = ''
                    let targetNode = newNode && newNode.text ? newNode : node
                    if (targetNode && targetNode.text) {

                        id = targetNode.id
                    }
                    if (event.name == 'node:unchecked') {
                        if (node.states.expanded) {
                            return; 
                        }
                        if(!goble.removeID.includes(id)) {
                            goble.removeNodes.push({
                                data: targetNode.data,
                                children: targetNode.children,
                                parent: targetNode.parent,
                            })
                            goble.removeID.push(id);
                        }
                        // if ((!goble.removeID.includes(id) && goble.nodeTick == null) || (!goble.removeID.includes(id) && goble.nodeTick != null && goble.nodeTick.parent && goble.nodeTick.parent.id != id)) {
                        //     goble.removeID.push(id);
                        // }
                        if (goble.checkedIDUpdate.includes(id)) {
                            goble.checkedIDUpdate = goble.checkedIDUpdate.filter(e => e !== id)
                        }
                        goble.checkedID = goble.checkedID.filter(e => e.id !== id)
                    }
                    if (event.name == 'node:checked') {
                        goble.removeID = goble.removeID.filter(e => e !== id);
                        if (!goble.checkedIDUpdate.includes(id)) {
                            goble.checkedIDUpdate.push(id);
                        }
                        if (!goble.checkedID.includes(id)) {
                            goble.checkedID.push(id);
                        }

                    }

                    if((arguments[1]== undefined && arguments.length ==2) && event.name == 'node:checked'){
                        if (!goble.checkedTrueID.includes(id)) {
                            goble.checkedTrueID.push(id);
                        }
                    }
                    if((arguments[1]== undefined && arguments.length == 2) && event.name == 'node:unchecked'){
                        if (goble.checkedTrueID.includes(id)) {
                            goble.checkedTrueID = goble.checkedTrueID.filter(e => e !== id);
                        }
                    }
                    goble.nodeTick = targetNode;
                }
            },
            getData() {
                return new Promise((resolve, reject) => {
                    global.axios(`api/s-contracts/${this.$route.params.id}/tree-properties/0`, {
                        method: "GET",
                        params: {
                            // is_active: true
                        },
                        headers: {
                            Accept: "application/json",
                        }
                    })
                        .then(response => {
                            this.rootId = response.data.data[0].data.id;
                            this.isLoading = false;
                            resolve(response.data.data);
                        })
                        .catch(error => reject(error));
                });
            },
            async select(node) {
                if (!node.data.created_at) {
                    let ServiceCategoryInfo = await global.axios(`api/contracts/${this.$route.params.id}/properties/${node.data.id}`, {
                        method: "GET",
                        data: {},
                        headers: {
                            Accept: "application/json",
                        }
                    });
                    delete ServiceCategoryInfo.data.data.children;
                    delete ServiceCategoryInfo.data.data.data;
                    node.data = ServiceCategoryInfo.data.data
                }
                this.nodeInfo.parents = ''
                if(node.parent)
                    this.nodeInfo.parents = node.parent.data.text;
                this.nodeInfo.type = node.data.type;
                this.nodeInfo.name = node.data.text;
                this.breadCrumb = node.data.root_path;
            },
            refreshProperty() {
                this.isLoading = true;
                global.axios(`api/s-contracts/${this.$route.params.id}/tree-properties/0`, {
                    method: "GET",
                    headers: {
                        Accept: "application/json",
                    }
                }).then(response => {
                    this.isLoading = false;
                    this.rootId = response.data.data[0].data.id;
                    this.$refs.tree.tree.setModel(response.data.data);
                })
                .catch(error => {
                    this.isLoading = false;
                });
            },
            save(){
                if (this.timer.save) {
                    clearTimeout(this.timer.save);
                    this.timer.save = null;
                }
                this.timer.save = setTimeout(() => {
                    let parents = {};
                    for (let index = 0; index < this.removeNodes.length; index++) {
                        const item = this.removeNodes[index];
                        if(item.children.length > 0) {
                            parents[item.data.id] = item.children.map(node => node.data.id)
                        }
                    }

                    // Check each parent's children against removeID
                    for (const parentId in parents) {
                        const children = parents[parentId];
                        // Count how many children are in removeID
                        const childrenInRemoveIDCount = children.reduce((count, childId) => 
                            this.removeID.includes(childId) ? count + 1 : count, 0
                        );

                        if (childrenInRemoveIDCount == children.length) {
                            // Remove all children IDs and parent ID from removeID
                            this.removeID = this.removeID.filter(id => 
                                !children.includes(id) && id !== parentId
                            );
                        } else {
                            // If not all children are in removeID, remove the parent ID
                            if(childrenInRemoveIDCount > 0 &&parentId != this.rootId)
                                this.removeID = this.removeID.filter(id => id != parentId);
                        }
                    }
                    for (let i = 0; i < this.removeID.length; i++) {
                        const removeId = this.removeID[i];
                        const matchingNode = this.removeNodes.find(node => node.data.id === removeId);
                        
                        if (matchingNode && matchingNode.parent) {
                            const siblings = matchingNode.parent.children;
                            const allSiblingsUnchecked = siblings.every(sibling => 
                                sibling.states.checked === false || sibling.data.id === removeId
                            );
                            
                            if (allSiblingsUnchecked) {
                                // Add parent ID if not already in removeID
                                if (!this.removeID.includes(matchingNode.parent.data.id)) {
                                    if(this.removeID.length > 1 && !matchingNode.parent.parent){
                                        continue;
                                    }
                                    
                                    // Remove current node ID
                                    this.removeID.splice(i, 1);
                                    i--; // Adjust index since we removed an element

                                    this.removeID.push(matchingNode.parent.data.id);
                                }
                            }
                        }
                    }

                    if(this.isAction) return
                    this.isAction = true;
                    const data = {
                        id: this.$route.params.id,
                        removeID: this.removeID,
                        dataID: this.checkedID,
                        checkedTrueID: this.checkedTrueID,
                        supplier_contract_id: this.$route.params.id,
                        is_safety: true
                    }
                    this.$store.dispatch('PropertyController/saveCheckedProperties', data)
                        .then(result => {
                            this.checkedID = [];
                            this.removeID = [];
                            this.isAction = false;
                            this.$alertNotification(this.$notificationV2('editing', 'vendor_linking_property'));
                        })
                        .catch(error => {
                            this.isAction = false;
                        })
                }, 500);
            }
        }
    }
</script>